/* my aurea - bag, search and account.

   The design is the one from the build; the data underneath is Shopify's.
   Everything the shop needs is handed in from Liquid as window.__AUREA_SHOP__,
   so this file never guesses a variant id or a URL.

   Cart state always comes back from Shopify. We never keep our own copy of it,
   which is what stops the drawer and the checkout disagreeing.                */

(function () {
  var S = window.__AUREA_SHOP__;
  if (!S) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var byKey = {}, byVariant = {};
  (S.products || []).forEach(function (p) {
    byKey[p.key] = p;
    byVariant[String(p.variantId)] = p;
    if (p.sellingPlanId) byVariant[p.variantId + ':' + p.sellingPlanId] = p;
  });

  function el(id) { return document.getElementById(id); }
  function esc(t) {
    return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  /* Prices are printed in the shop currency and in the shape the language
     module recognises, so switching currency rewrites them too. */
  function money(cents) {
    var v = cents / 100;
    return S.currency + ' ' + (v % 1 ? v.toFixed(2) : v.toFixed(0));
  }

  /* ---------- talking to the cart ---------- */
  var cart = { items: [], total_price: 0, item_count: 0 };
  var busy = false;

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    });
  }
  function pull() {
    return fetch(S.cartUrl, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart = c; paintBag(); return c; });
  }
  function guard(p) {
    busy = true; paintBusy();
    return p.then(pull).catch(shout).then(function () { busy = false; paintBusy(); });
  }
  function shout(e) {
    var box = el('bagError');
    if (!box) return;
    box.textContent = (e && (e.description || e.message)) || 'That did not go through. Try again.';
    box.hidden = false;
    window.setTimeout(function () { box.hidden = true; }, 5000);
  }
  function paintBusy() {
    var d = el('dwBag');
    if (d) d.classList.toggle('is-busy', busy);
  }

  function add(key, plan) {
    var p = byKey[key];
    if (!p) return;
    var line = { id: p.variantId, quantity: 1 };
    if (plan === 'sub' && p.sellingPlanId) line.selling_plan = p.sellingPlanId;
    return guard(post(S.addUrl, { items: [line] })).then(function () { open('bag'); });
  }
  function addMany(keys, plan) {
    var lines = [];
    keys.forEach(function (k) {
      var p = byKey[k];
      if (!p) return;
      var line = { id: p.variantId, quantity: 1 };
      if (plan === 'sub' && p.sellingPlanId) line.selling_plan = p.sellingPlanId;
      lines.push(line);
    });
    if (!lines.length) return;
    return guard(post(S.addUrl, { items: lines })).then(function () { open('bag'); });
  }
  function setQty(lineKey, n) {
    return guard(post(S.changeUrl, { id: lineKey, quantity: Math.max(0, n) }));
  }
  function empty() { return guard(post(S.clearUrl, {})); }

  /* Shopify cannot move a line between plans in place, so the line is removed
     and put back on the other plan, keeping its quantity. */
  function setPlan(item, plan) {
    var p = byVariant[String(item.variant_id)];
    if (!p) return;
    var line = { id: p.variantId, quantity: item.quantity };
    if (plan === 'sub' && p.sellingPlanId) line.selling_plan = p.sellingPlanId;
    return guard(
      post(S.changeUrl, { id: item.key, quantity: 0 })
        .then(function () { return post(S.addUrl, { items: [line] }); })
    );
  }

  /* ---------- the drawer ---------- */
  var bagBody = el('bagBody'), bagFoot = el('bagFoot'), bagCount = el('bagCount');
  var headCounts = document.querySelectorAll('.bagn');

  function bump() {
    Array.prototype.forEach.call(headCounts, function (n) {
      n.classList.remove('is-bump'); void n.offsetWidth; n.classList.add('is-bump');
    });
  }

  function lineOf(item, idx) {
    var p = byVariant[String(item.variant_id)] || {};
    var sub = !!item.selling_plan_allocation;
    var was = item.original_line_price, now = item.final_line_price;
    var canSub = !!p.sellingPlanId;
    return '<div class="li" style="--lc:' + esc(p.color || 'var(--signal)') + '">'
      + '<span class="li__art">' + (item.image
          ? '<img src="' + esc(item.image) + '" alt="" width="70" height="79" loading="lazy">' : '')
        + '</span>'
      + '<div><p class="li__name">' + esc(item.product_title) + '</p>'
      + '<p class="li__meta">' + esc(p.flavor || item.variant_title || '') + '</p>'
      + (canSub
          ? '<span class="li__plans" role="group" aria-label="How this is delivered">'
            +   '<button type="button" data-plan="' + idx + '" data-to-plan="sub"'
            +     ' aria-pressed="' + sub + '">Subscribe'
            +     (S.saveLabel ? ' <b>' + esc(S.saveLabel) + '</b>' : '') + '</button>'
            +   '<button type="button" data-plan="' + idx + '" data-to-plan="once" aria-pressed="'
            +     (!sub) + '">One time</button>'
            + '</span>'
          : '')
      + '<span class="li__when">' + (sub
          ? esc(item.selling_plan_allocation.selling_plan.name)
          : 'One delivery, full price.') + '</span>'
      + '<span class="li__qty"><button type="button" data-less="' + idx + '" aria-label="One fewer">'
      + '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round"><path d="M5 12h14"/></svg></button>'
      + '<b>' + item.quantity + '</b>'
      + '<button type="button" data-more="' + idx + '" aria-label="One more">'
      + '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg></button></span></div>'
      + '<div class="li__right"><span class="li__price">'
      + (was > now ? '<s>' + money(was) + '</s>' : '') + money(now) + '</span>'
      + '<button class="li__drop" type="button" data-drop="' + idx + '">Remove</button></div>'
      + '</div>';
  }

  function paintBag() {
    var n = cart.item_count || 0;
    Array.prototype.forEach.call(headCounts, function (e) { e.textContent = n; });
    if (bagCount) bagCount.textContent = n === 1 ? '1 jar' : n + ' jars';
    if (!bagBody) return;

    if (!n) {
      bagBody.innerHTML =
        '<div class="empty"><h3>Nothing in the bag yet.</h3><p>' + esc(S.emptyLine || '') + '</p></div>'
        + '<div class="quick">' + (S.products || []).map(function (p) {
            return '<button type="button" data-quick="' + esc(p.key) + '" style="--qc:' + esc(p.color) + '">'
              + (p.image ? '<img src="' + esc(p.image) + '" alt="" width="64" height="72" loading="lazy">' : '')
              + '<span><b>' + esc(p.title) + '</b><i>' + esc(p.flavor) + '</i></span><em>Add</em></button>';
          }).join('') + '</div>';
      if (bagFoot) bagFoot.hidden = true;
      wire();
      return;
    }

    if (bagFoot) bagFoot.hidden = false;
    bagBody.innerHTML = cart.items.map(lineOf).join('');

    var gross = cart.items.reduce(function (s, i) { return s + i.original_line_price; }, 0);
    var net = cart.total_price;
    var left = Math.max(0, (S.freeShipping || 0) - net);
    var fill = el('shipFill'), note = el('shipNote');
    if (fill) fill.style.width = Math.min(100, S.freeShipping ? (net / S.freeShipping) * 100 : 100) + '%';
    if (note) note.innerHTML = left
      ? '<b>' + money(left) + '</b> more for free shipping.'
      : '<b>Free shipping</b> is included.';
    el('sumGross').textContent = money(gross);
    el('sumSave').innerHTML = '&minus;' + money(gross - net);
    el('sumSaveRow').hidden = gross - net <= 0;
    el('sumTotal').textContent = money(net);
    wire();
    bump();
  }

  function wire() {
    bagBody.querySelectorAll('[data-quick]').forEach(function (b) {
      b.addEventListener('click', function () { add(b.dataset.quick, 'sub'); });
    });
    bagBody.querySelectorAll('[data-more]').forEach(function (b) {
      b.addEventListener('click', function () {
        var i = cart.items[+b.dataset.more]; setQty(i.key, i.quantity + 1);
      });
    });
    bagBody.querySelectorAll('[data-less]').forEach(function (b) {
      b.addEventListener('click', function () {
        var i = cart.items[+b.dataset.less]; setQty(i.key, i.quantity - 1);
      });
    });
    bagBody.querySelectorAll('[data-drop]').forEach(function (b) {
      b.addEventListener('click', function () { setQty(cart.items[+b.dataset.drop].key, 0); });
    });
    bagBody.querySelectorAll('[data-plan]').forEach(function (b) {
      b.addEventListener('click', function () {
        var i = cart.items[+b.dataset.plan];
        var sub = !!i.selling_plan_allocation;
        var want = b.dataset.toPlan;
        if ((want === 'sub') !== sub) setPlan(i, want);
      });
    });
  }

  /* ---------- overlays ---------- */
  var ov = el('ov');
  var panels = { bag: el('dwBag'), acct: el('dwAcct'), search: el('shSearch') };
  var openPanel = null, lastFocus = null;

  function open(name) {
    if (!panels[name]) return;
    if (openPanel === name) return close();
    if (openPanel) hide(openPanel);
    lastFocus = document.activeElement;
    openPanel = name;
    var p = panels[name];
    p.hidden = false; ov.hidden = false;
    document.body.classList.add('is-locked');
    window.requestAnimationFrame(function () { ov.classList.add('is-on'); p.classList.add('is-on'); });
    var first = p.querySelector('input, button, a');
    if (first) window.setTimeout(function () { first.focus(); }, reduce ? 0 : 260);
  }
  function hide(name) {
    var p = panels[name];
    p.classList.remove('is-on');
    window.setTimeout(function () { p.hidden = true; }, reduce ? 0 : 460);
  }
  function close() {
    if (!openPanel) return;
    hide(openPanel);
    openPanel = null;
    ov.classList.remove('is-on');
    window.setTimeout(function () { ov.hidden = true; }, reduce ? 0 : 400);
    document.body.classList.remove('is-locked');
    if (lastFocus) lastFocus.focus();
  }
  if (ov) ov.addEventListener('click', close);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openPanel) { e.preventDefault(); close(); }
    if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') { e.preventDefault(); open('search'); }
    if (e.key === 'Tab' && openPanel) trap(e);
  });
  function trap(e) {
    var f = panels[openPanel].querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  document.querySelectorAll('[data-open]').forEach(function (b) {
    var name = b.getAttribute('data-open');
    if (panels[name]) b.addEventListener('click', function (e) { e.preventDefault(); open(name); });
  });
  document.querySelectorAll('.dw .x, .sh .x').forEach(function (b) { b.addEventListener('click', close); });

  /* ---------- search, against Shopify's own suggestions ---------- */
  var sInput = el('shInput'), sOut = el('shOut'), sHint = el('shHint'), sChips = el('shChips');
  var cursor = -1, timer = null, lastQ = '';

  function results(q) {
    var url = S.suggestUrl + '?q=' + encodeURIComponent(q)
      + '&resources[type]=product,page&resources[limit]=6';
    return fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) { return (d.resources && d.resources.results) || {}; });
  }
  function renderSearch(r, q) {
    var products = r.products || [], pages = r.pages || [];
    var rows = products.map(function (p) {
      return '<a class="res" href="' + esc(p.url) + '">'
        + (p.featured_image && p.featured_image.url
            ? '<img src="' + esc(p.featured_image.url) + '" alt="" width="44" height="50" loading="lazy">' : '<span></span>')
        + '<b>' + esc(p.title) + '<span>' + esc(p.body || '') + '</span></b>'
        + '<em>' + esc(p.price ? money(parseInt(p.price, 10)) : '') + '</em></a>';
    }).concat(pages.map(function (p) {
      return '<a class="res res--page" href="' + esc(p.url) + '"><span></span>'
        + '<b>' + esc(p.title) + '<span>Page</span></b><em></em></a>';
    }));
    if (!rows.length) {
      sHint.textContent = 'No match';
      sOut.innerHTML = '<div class="sh__none"><b>Nothing for &ldquo;' + esc(q) + '&rdquo;.</b>'
        + '<span>Here is everything we ship today.</span></div>'
        + (S.products || []).map(function (p) {
            return '<a class="res" href="' + esc(p.url) + '">'
              + (p.image ? '<img src="' + esc(p.image) + '" alt="" width="44" height="50" loading="lazy">' : '<span></span>')
              + '<b>' + esc(p.title) + '<span>' + esc(p.flavor) + '</span></b>'
              + '<em>' + money(p.price) + '</em></a>';
          }).join('');
    } else {
      sHint.textContent = rows.length === 1 ? '1 result' : rows.length + ' results';
      sOut.innerHTML = rows.join('');
    }
    cursor = -1;
  }
  function idle() {
    sHint.textContent = 'The range';
    sOut.innerHTML = (S.products || []).map(function (p) {
      return '<a class="res" href="' + esc(p.url) + '">'
        + (p.image ? '<img src="' + esc(p.image) + '" alt="" width="44" height="50" loading="lazy">' : '<span></span>')
        + '<b>' + esc(p.title) + '<span>' + esc(p.flavor) + '</span></b>'
        + '<em>' + money(p.price) + '</em></a>';
    }).join('');
  }
  if (sInput) {
    sInput.addEventListener('input', function () {
      var q = sInput.value.trim();
      window.clearTimeout(timer);
      if (!q) { idle(); return; }
      timer = window.setTimeout(function () {
        if (q === lastQ) return;
        lastQ = q;
        results(q).then(function (r) { renderSearch(r, q); }).catch(function () { idle(); });
      }, 160);
    });
    sInput.addEventListener('keydown', function (e) {
      var rows = sOut.querySelectorAll('.res');
      if (!rows.length) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); cursor = (cursor + 1) % rows.length; }
      else if (e.key === 'ArrowUp') { e.preventDefault(); cursor = (cursor - 1 + rows.length) % rows.length; }
      else if (e.key === 'Enter' && cursor > -1) { e.preventDefault(); rows[cursor].click(); return; }
      else return;
      rows.forEach(function (r, i) { r.classList.toggle('is-on', i === cursor); });
      rows[cursor].scrollIntoView({ block: 'nearest' });
    });
  }
  if (sChips) sChips.querySelectorAll('button').forEach(function (b) {
    b.addEventListener('click', function () {
      sInput.value = b.dataset.q;
      sInput.dispatchEvent(new Event('input', { bubbles: true }));
      sInput.focus();
    });
  });

  /* ---------- anything on a page can fill the bag ---------- */
  window.aureaAdd = add;
  window.aureaAddMany = addMany;
  window.aureaBagAnchor = function () {
    var b = document.querySelector('[data-open="bag"]');
    return b ? b.getBoundingClientRect() : null;
  };

  /* emptying is one click to do and none to undo, so it asks once */
  (function () {
    var b = el('bagClear'), armed = false, t = null;
    if (!b) return;
    function rest() { armed = false; b.textContent = 'Empty the bag'; b.classList.remove('is-sure'); }
    b.addEventListener('click', function () {
      if (!armed) {
        armed = true; b.textContent = 'Tap again to empty'; b.classList.add('is-sure');
        window.clearTimeout(t); t = window.setTimeout(rest, 3200);
        return;
      }
      window.clearTimeout(t); rest(); empty();
    });
  })();

  if (sOut) idle();
  pull();
})();
